import { useCookies } from "react-cookie";
import { useAppSelector } from "../store/hooks";
import { selectRobot } from "../store/ses/sesRobotSlice";
import { LIST_OF_UNCOMMITTED_ROBOTS } from "../constants/cookieNames";

const useUncommittedRobotsList = () => {
	const robotInfo = useAppSelector(selectRobot); // store - информация о роботе

	const [cookies, setCookie] = useCookies([LIST_OF_UNCOMMITTED_ROBOTS]); // hook для работы с cookie

	return (action: "add" | "delete" | "deleteAll", robotIdWithPostfix?: string): void => {
		const robotId = robotIdWithPostfix || robotInfo.data?.id; // если есть принудительное прокидывание id
		if (action === "add") {
			// добавляем в куки id незакомиченного робота
			if (Array.isArray(cookies.listOfUncommittedRobots)) {
				if (!cookies.listOfUncommittedRobots.includes(robotId)) {
					setCookie(LIST_OF_UNCOMMITTED_ROBOTS, [...cookies.listOfUncommittedRobots, robotId], { path: "/", maxAge: 2_592_000 }); // устанавливаем cookie на месяц
				}
			} else {
				setCookie(LIST_OF_UNCOMMITTED_ROBOTS, [robotId], { path: "/", maxAge: 2_592_000 }); // устанавливаем cookie на месяц
			}
		} else if (action === "delete") {
			// удаляем из куки id закоммиченного робота
			if (Array.isArray(cookies.listOfUncommittedRobots)) {
				setCookie(
					LIST_OF_UNCOMMITTED_ROBOTS,
					cookies.listOfUncommittedRobots.filter((id) => id !== robotId),
					{ path: "/", maxAge: 2_592_000 }
				); // устанавливаем cookie на месяц
			} else {
				setCookie(LIST_OF_UNCOMMITTED_ROBOTS, [], { path: "/", maxAge: 2_592_000 }); // устанавливаем cookie на месяц
			}
		} else {
			// удаляем из куки id закоммиченных версий роботов
			if (Array.isArray(cookies.listOfUncommittedRobots)) {
				setCookie(
					LIST_OF_UNCOMMITTED_ROBOTS,
					cookies.listOfUncommittedRobots.filter((id) => id?.replace(/(_prod)|(_backup)$/, "") !== robotId?.replace(/(_prod)|(_backup)$/, "")),
					{ path: "/", maxAge: 2_592_000 }
				); // устанавливаем cookie на месяц
			} else {
				setCookie(LIST_OF_UNCOMMITTED_ROBOTS, [], { path: "/", maxAge: 2_592_000 }); // устанавливаем cookie на месяц
			}
		}
	};
};

export default useUncommittedRobotsList;
